import { UtilsService } from './services/utils.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { PublicModule } from './modules/public/public.module';
import { AppRoutingModule } from './app-routing.module';
import { DashboardModule } from './modules/dashboard/dashboard.module';

import { ClientsService } from './services/clients.service';
import { TokenInterceptor } from './interceptors/http.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WorkersService } from './services/workers.service';
import { MessagesService } from './services/messages.service';




@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    PublicModule,
    AppRoutingModule,
    DashboardModule,
    BrowserAnimationsModule
  ],
  bootstrap: [AppComponent],
  providers: [
    ClientsService,
    UtilsService,
    MessagesService,
    WorkersService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }]
})
export class AppModule { }
